// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"feeb2282","661":"804c48e3","787":"d4aa38ea"}[chunkId] + ".chunk.js";
};